<template>
  <div class="salesmanmybonusdetailPage">
    <XR-head :titleText="pageTitle" :rightShow="false" ref="headObj"></XR-head>
      <mu-list v-if="awardData.DetailList">
        <!-- <template v-for="awardItem in awardData.DetailList">
          <mu-list-item  title="" :key="awardItem.award_Type">
            <div class="mu-item-title" >{{awardItem.award_TypeName}}</div>
            <div class="mu-item-title" slot="right">+{{awardItem.award_Total.toFixed(2)}}</div>      
          </mu-list-item>
          <mu-divider shallowInset />  
        </template> -->
        <template>
          <mu-list-item  title="">
            <div class="mu-item-title" >合计</div>
            <div class="mu-item-title" slot="right">+{{awardData.Total}}</div>        
          </mu-list-item>
          <mu-divider shallowInset/>
        </template>
        <template>
          <mu-list-item  title="">
            <div class="mu-item-title" >税费</div>
            <div class="mu-item-title" slot="right"><span style="color:black">-</span>{{awardData.Tax}}</div>        
          </mu-list-item>
          <mu-divider shallowInset/>
        </template>
        <template>
          <mu-list-item  title="">
            <div class="mu-item-title" >实发</div>
            <div class="mu-item-title" slot="right">+{{awardData.Real}}</div>        
          </mu-list-item>
        </template>
      </mu-list>
      <XR-toast ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pageTitle: this.$route.query.type == 1 ? "零售奖金" : this.$route.query.type == 2 ? "推广奖金" :'批发奖金',
      queryInfo: {
        zqnum: this.$route.query.zqnum,
        type:this.$route.query.type
      },
      awardData: {},
      totalAward: 0,
      dateTime: ""
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      var ths = this;

      var url = "/Salesman/SalesmanServer/MobileGetShopJiesuanGoldDetail";

      ths.$post(url, this.queryInfo).then(function(res) {
        if (!res.IsSuccess) {
          ths.awardData = {};
          ths.$refs.XRtoast.failed(res.Msg, true);
        } else {
          ths.awardData = res.Data;
        }
      });
    }
  }
};
</script>

<style>
body .salesmanmybonusdetailPage {
  background: #fff;
}
.salesmanmybonusdetailPage .mu-list {
  margin-top: 10px;
}
.salesmanmybonusdetailPage .mu-item-title {
  font-size: 12px;
}
.salesmanmybonusdetailPage .mu-item-right {
  text-align: center;
  width: 20%;
}
.salesmanmybonusdetailPage .mu-item-content p {
  color: #aaa;
}
.salesmanmybonusdetailPage .mu-item-right .mu-item-title {
  font-size: 14px;
  color: red;
}
</style>




// WEBPACK FOOTER //
// src/pages/salesman/mybonusdetail.vue